import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {IDatepickerSchema, ToastService} from "maps-angular-components";
import {Subject, Subscription} from "rxjs";

import {BrowserSupport} from "../../shared/util/browser-support";
import {DetalheModel} from "../../shared/modal-detalhe-alteracoes/detalhe-model";
import {DoubleCheckType} from "../feito-conferido/double-check-type";
import {FeitoConferido} from "../feito-conferido";
import {FeitoConferidoAction} from "../feito-conferido/feito-conferido-action";
import {FeitoConferidoService} from "../feito-conferido.service";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {MemoriaCalculoComponent} from "../../memoria-calculo/memoria-calculo.component";
import {ModalDetalheAlteracoesComponent} from "../../shared/modal-detalhe-alteracoes/modal-detalhe-alteracoes.component";
import {ResultadoRegra} from "../../resultado-regra/resultado-regra";
import {indicate} from "../../shared/util/loading-indicate";

@Component({
  selector: 'app-feito-conferido-pesquisa',
  templateUrl: './feito-conferido-pesquisa.component.html',
  styleUrls: ['./feito-conferido-pesquisa.component.scss']
})
export class FeitoConferidoPesquisaComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  data: FeitoConferido[] = [];
  form: FormGroup;
  feitoConferidos: FeitoConferido[] = [];
  paginationTotalPage = 1;
  public totalRegistros = 0;

  acao = FeitoConferidoAction.getTiposAction;
  tipos: DoubleCheckType[];
  loading$: Subject<boolean> = new Subject<boolean>();

  loadingExport$: Subject<boolean> = new Subject<boolean>();
  page$: Subject<number> = new Subject<number>();

  public dataSchema: IDatepickerSchema;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly messageService: ToastService,
    private readonly feitoConferidoService: FeitoConferidoService,
    private readonly changeDetector: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.subscriptions.add(this.getTipos());
    this.form = this.formBuilder.group({
      authDate: new FormControl(),
      username: new FormControl(),
      action: new FormControl(),
      entryType: new FormControl(),
      description: new FormControl(),
      page: new FormControl(0),
      itensPerPage: new FormControl(20)
    });

    this.page$.subscribe(value => {
      this.form.controls.page.setValue(value - 1);
      this.pesquisar();
    });

    this.dataSchema = {
      label: "Data ",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      panelClass: "w-100",
      formControlName: "authDate"
    };
  }

  openEditDialog(feitoConferido: FeitoConferido) {
    this.dialog.open(ModalDetalheAlteracoesComponent, {
      data: {
        entryType: feitoConferido.entryType,
        entityModel: feitoConferido.entityModel
      },
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  getTipos() {
    return this.feitoConferidoService.getDoubleCheckType()
      .subscribe(tipos => {
          this.tipos = tipos
        }
      );
  }

  autorizar(id: any) {
    this.messageService.textoLight("Autorização realizada com sucesso.");
    this.removeFeitoConferido(id);
  }

  rejeitar(id: any){
    this.messageService.textoLight("Autorização rejeitada com sucesso.");
    this.removeFeitoConferido(id);
  }

  notificarErro(mensagem: string) {
    this.messageService.erro(mensagem);
  }

  private removeFeitoConferido(id: any) {
    const index = this.feitoConferidos.map(feitoconferido => feitoconferido.id).indexOf(id);
    this.feitoConferidos.splice(index, 1);
    this.totalRegistros--;
    this.changeDetector.detectChanges();

    if (this.feitoConferidos.length == 0) {
      this.pesquisar();
    }
  }

  pesquisar() {
    this.feitoConferidos = [];
    this.totalRegistros = 0;
    this.subscriptions.add(
      this.feitoConferidoService
        .search(this.form.value)
        .pipe(indicate(this.loading$))
        .subscribe(
          res => {
            if (res.metadata.totalElements > 0) {
              if (res.metadata.size === 0) {
                this.paginationTotalPage = 1;
              } else {
                this.paginationTotalPage = Math.ceil(
                  res.metadata.totalElements / res.metadata.size
                );
              }
              this.totalRegistros = res.metadata.totalElements;
              this.feitoConferidos = res.content.map(e =>
                Object.assign(new FeitoConferido(), e)
              );
              this.form.get("page").setValue(res.metadata.number);
            } else {
              this.paginationTotalPage = 1;
            }
          },
          err => {
            this.messageService.erro(err.error?.message || err.message);
          }
        )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  exportarPdf() {
    this.subscriptions.add(
      this.feitoConferidoService.exportPdf(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.savePDF(data);
      }, err => this.messageService.erro(err.error.message)));
  }

  exportarXls() {
    this.subscriptions.add(
      this.feitoConferidoService.exportXlsx(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.saveXlsx(data);
      }, err => this.messageService.erro(err.error.message)));
  }

  confirmDialog(r: ResultadoRegra) {
    this.dialog.open(MemoriaCalculoComponent, {
      data: r,
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  receiverPage(value) {
    this.page$.next(value);
  }

    getDescription(action: string) {
        return FeitoConferidoAction.fromString(action).name;
    }

  changeItensPerPage($event: any) {
    this.form.controls.itensPerPage.setValue($event);
    this.page$.next(1);
  }
}
